module.exports = __webpack_public_path__ + "img/njhkhtdx.6cca887.png";